/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { MGear, MGearInterface } from "../MGear";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IMineablePunks",
        name: "_mineablePunks",
        type: "address",
      },
      {
        internalType: "contract IMineableWords",
        name: "_mineableWords",
        type: "address",
      },
      {
        internalType: "contract IMGear",
        name: "_mgear",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "normal",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "solid",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "noteworthy",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "hashed",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "mpunk",
        type: "uint256",
      },
    ],
    name: "getTransmutationRarity",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    name: "inscribed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mgearRenderer",
    outputs: [
      {
        internalType: "contract IMGear",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mineablePunks",
    outputs: [
      {
        internalType: "contract IMineablePunks",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mineableWords",
    outputs: [
      {
        internalType: "contract IMineableWords",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint96",
        name: "nonce",
        type: "uint96",
      },
      {
        internalType: "uint8",
        name: "rarity",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "mwordIndex",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "nameFormat",
        type: "uint8",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "mpunkRolls",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rarityToDifficulties",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rarityToUpgradeRoll",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "mwordIndex",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "nameFormat",
        type: "uint8",
      },
    ],
    name: "rename",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "renderData",
    outputs: [
      {
        internalType: "string",
        name: "data",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokenDataTokenId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokenIdToMGear",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mpunk",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "mwordIndex",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "nameFormat",
        type: "uint8",
      },
    ],
    name: "transmute",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "transmuted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

export class MGear__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _mineablePunks: string,
    _mineableWords: string,
    _mgear: string,
    normal: BigNumberish,
    solid: BigNumberish,
    noteworthy: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MGear> {
    return super.deploy(
      _mineablePunks,
      _mineableWords,
      _mgear,
      normal,
      solid,
      noteworthy,
      overrides || {}
    ) as Promise<MGear>;
  }
  getDeployTransaction(
    _mineablePunks: string,
    _mineableWords: string,
    _mgear: string,
    normal: BigNumberish,
    solid: BigNumberish,
    noteworthy: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _mineablePunks,
      _mineableWords,
      _mgear,
      normal,
      solid,
      noteworthy,
      overrides || {}
    );
  }
  attach(address: string): MGear {
    return super.attach(address) as MGear;
  }
  connect(signer: Signer): MGear__factory {
    return super.connect(signer) as MGear__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MGearInterface {
    return new utils.Interface(_abi) as MGearInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): MGear {
    return new Contract(address, _abi, signerOrProvider) as MGear;
  }
}
